import {
  getVillageList,
  addDemandInvite,
  getInviteInfo
} from '@/api/customerConsultant.js'

import { getToken, setToken } from '@/utils/auth'
import { Notify } from 'vant'
import { login } from '@/api/staff'

const state = {
  token: getToken()
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  }
}

const actions = {
  setToken({ state, commit }, token) {
    commit('SET_TOKEN', token)
  },
  async login({ state, commit, dispatch }, data) {
    try {
      const res = await login(data)
      const { staff_access_info } = res.data.data
      const token = staff_access_info.token
      dispatch('setToken', token)
      return res.data.data
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      await dispatch('setToken', token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  // 12-获取小区
  getVillageList(temp, data) {
    return new Promise((resolve, reject) => {
      getVillageList(data).then(response => {
        const data = response.data.data
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (rad1)-06-邀请涵详情
  getInviteInfo(temp, data) {
    return new Promise((resolve, reject) => {
      getInviteInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // A-11-(rad1)创建需求邀请
  addDemandInvite(temp, data) {
    return new Promise((resolve, reject) => {
      addDemandInvite(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
